import { render, staticRenderFns } from "./RatingStat.vue?vue&type=template&id=127d0b6c&scoped=true"
import script from "./RatingStat.vue?vue&type=script&lang=js"
export * from "./RatingStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d0b6c",
  null
  
)

export default component.exports